import NC_SCHEMA_DATA from '@ThemesApp/common/constants/schema/organization/nc';

import speakableSpecification from '@ThemesApp/common/structuredData/types/speakableSpecification';
import {personType} from '@ThemesApp/common/structuredData/personType';

const getTimeRequired = timeRequired => ({
  'timeRequired': `PT${timeRequired}M`
});

const personSchema = (id, data, siteUrl) => {
  const url = data?.slug && `${siteUrl}/o-nas/${data?.slug}`;

  return {
    ...(url && {id: `${url}#${id}`}),
    ...(data?.hasAuthorPage && url && {url}),
    brand: {
      logo: NC_SCHEMA_DATA.logo,
      slogan: NC_SCHEMA_DATA.slogan
    },
    ...(data?.hasOccupation && {
      hasOccupation: {
        sameAs: data?.hasOccupation
      }
    }),
    ...(data?.description?.description && {disambiguatingDescription: data?.description.description}),
    ...(data?.firstName && {givenName: data?.firstName}),
    ...(data?.additionalName && {additionalName: data?.additionalName}),
    ...(data?.lastName && {familyName: data?.lastName}),
    ...(data?.role && {jobTitle: data?.role}),
    ...(data?.image?.url && data?.firstName && data?.lastName && {
      image: {
        caption: `${data?.firstName} ${data?.lastName}`,
        id: `${data?.url}#authorImage`,
        url: data?.image?.url
      }
    }),
    publishingPrinciples: 'https://natu.care/pl/o-nas/proces-redakcyjny',
    ...(data?.honorificSuffix && {honorificSuffix: data?.honorificSuffix}),
    ...((data?.linkedin || data?.muckrack || data?.honorificSuffixDescription) && {
      sameAs: [
        data?.linkedin && data?.linkedin,
        data?.muckrack && data?.muckrack,
        data?.honorificSuffixDescription && data?.honorificSuffixDescription]
    }),
    ...(data?.knowsAbout && {knowsAbout: [data?.knowsAbout]}),
    ...(data?.email && {email: data?.email}),
    worksFor: NC_SCHEMA_DATA
  };
};

export const getStructuredData = ({
                                    data,
                                    breadcrumbs,
                                    articleUrl,
                                    siteUrl,
                                    cleanContent,
                                    votes,
                                    faqList,
                                    timeRequired
                                  }) => {

  return {
    structuredData: {
      rating: {
        name: data.seo?.title || data.shortHeading || data.heading,
        ratingValue: votes?.score,
        reviewCount: votes?.votes
      },
      siteName: {
        name: 'Natu.Care',
        url: 'https://natu.care/pl'
      },
      breadcrumbs: {
        itemListElement: breadcrumbs.map(item => ({
          name: item.schemaLabel || item.label,
          item: item.schemaHref
        }))
      },
      webPage: {
        id: `${articleUrl}#webpage`,
        url: articleUrl,
        ...(data.featuredImage?.url && {
          image: {
            url: data?.featuredImage?.url,
            width: 1920,
            height: 1080,
            id: `${articleUrl}#image`
          }
        }),
        name: data.seo?.title || data.shortHeading || data.heading,
        inLanguage: data.node_locale,
        speakable: speakableSpecification(
          {
            xpath: [
              '/html/head/title'
            ],
            cssSelector: ['.blogPost_body']
          }
        ),
        datePublished: data.metaPublishedTime,
        dateModified: data.metaUpdatedTime,
        ...(data.reviewedBy && {
          reviewedBy: JSON.parse(personType(personSchema('personReviewer', data.reviewedBy, siteUrl)))
        })
      },
      article: {
        ...(timeRequired && getTimeRequired(timeRequired)),
        url: articleUrl,
        articleBody: cleanContent,
        articleSection: data.category?.heading || data.heading,
        authorId: data.author?.slug && `${siteUrl}/o-nas/${data.author.slug}`,
        editorId: data.editedBy?.slug && `${siteUrl}/o-nas/${data.editedBy?.slug}`,
        headline: data.seo?.title || data.shortHeading || data.heading,
        description: data.shortContent,
        datePublished: data.metaPublishedTime,
        dateModified: data.metaUpdatedTime,
        publisherId: siteUrl,
        subjectOfId: `${articleUrl}#faqPage`,
        images: [
          {
            id: `${articleUrl}#${data?.featuredImage?.url.split('/')[data?.featuredImage?.url.split('/').length - 1]}`,
            url: data?.featuredImage?.url,
            name: data.seo?.title || data.shortHeading || data.heading
          }
        ],
        copyrightYear: new Date().getFullYear()
      },
      ...(data?.author && {personTypeAuthor: personSchema('personAuthor', data.author, siteUrl)}),
      ...(data?.editedBy && {personTypeEditor: personSchema('personEditor', data.editedBy, siteUrl)}),
      ...(faqList && faqList?.length > 0 && {
        faqPage: {
          id: `${articleUrl}#faqPage`,
          mainEntity: faqList
        }
      })
    }
  };
};
